import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useUbigeoService } from "@/services/ubigeo.service";
import {
  loadingDepartamento,
  loadingDistrito,
  loadingProvincia,
  successGetDepartamentos,
  successGetDistritos,
  successGetProvincias,
} from "@/redux/actions/domcilio";

export const useUbigeo = () => {
  const { departamentos } = useSelector((state) => state.domicilio);

  const [currentDepartment, setCurrentDepartment] = useState("");
  const [currentProvince, setCurrentProvince] = useState("");
  const [currentDistrict, setCurrentDistrict] = useState("");

  const { getProvince, getDistrict, getDepartment } = useUbigeoService();

  const dispatch = useDispatch();

  useEffect(() => {
    if (departamentos.length === 0) {
      getDepartments();
    }
  }, []);

  const getDepartments = async () => {
    dispatch(loadingDepartamento());
    try {
      const resp = await getDepartment({ idePais: "428" });
      dispatch(successGetDepartamentos(resp));
    } catch (error) {
      console.error(error);
    }
  };

  const onChangeDepartment = async (id) => {
    if (String(id) === currentDepartment) return;
    setCurrentDepartment(String(id));
    setCurrentProvince("");
    setCurrentDistrict("");
    if (id !== "" && id !== undefined && id !== "undefined") {
      dispatch(loadingProvincia());
      const list = await getProvince({ ideDepartamento: String(id) });
      dispatch(successGetProvincias(list));
    }
  };

  const onChangeProvince = async (id) => {
    if (String(id) === currentDepartment) return;
    setCurrentProvince(String(id));
    setCurrentDistrict("");
    if (id !== "") {
      dispatch(loadingDistrito());
      const list = await getDistrict({
        ideProvincia: String(id),
        ideDepartamento: currentDepartment,
      });
      dispatch(successGetDistritos(list));
    }
  };

  const onChangeDistrict = (id) => {
    setCurrentDistrict(String(id));
  };

  const getProvinceDistrictTogether = async (departmentCode, provinceCode) => {
    try {
      dispatch(loadingProvincia());
      dispatch(loadingDistrito());
      const [provinces, districts] = await Promise.all([
        getProvince({ ideDepartamento: String(departmentCode) }),
        getDistrict({
          ideProvincia: String(provinceCode),
          ideDepartamento: String(departmentCode),
        }),
      ]);
      dispatch(successGetProvincias(provinces));
      dispatch(successGetDistritos(districts));
    } catch (error) {
      console.log(error);
    }
  };

  return {
    onChangeDepartment,
    onChangeProvince,
    onChangeDistrict,
    getProvinceDistrictTogether,
    setCurrentDepartment,
    currentDepartment,
    currentDistrict,
    currentProvince,
  };
};
